import React from 'react'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { useAuth } from '../../providers/AuthProvider.js'
import BodyText, { BoldSpan } from '../styles/Text.js'
import ConfirmationTemplate from '../common/ConfirmationTemplate.js'

function BillCancelledConfirmation({ secondaryId }) {
  const { authState } = useAuth()
  const showLogo = !authState.accessToken

  return (
    <ConfirmationTemplate title="Request Cancelled" bodyText={[]} showLogo={showLogo} showContact={config.showContact}>
      <BodyText>
        Your request <BoldSpan>{secondaryId}</BoldSpan> has been cancelled. You will receive a confirmation to your email.
      </BodyText>
    </ConfirmationTemplate>
  )
}

BillCancelledConfirmation.propTypes = {
  secondaryId: PropTypes.string.isRequired
}

export default BillCancelledConfirmation
